<mat-toolbar>
  <div class="menu d-print-none">
    <button mat-icon-button class="noOutline" (click)="menuClicked.emit()">
      <mat-icon>menu</mat-icon>
    </button>
  </div>
  <div class="full-width">
    <div class="row full-width" [class.toolbar-empty]="!rsf">
      <!-- Bug 6961: below md show the page title only while no record is open, so the header stays compact once one is -->
      <div class="col-md-2 d-print-none d-none d-md-flex align-items-center" [ngClass]="{ 'd-flex': !rsf }">
        <span class="toolbar-title">{{ moduleTitle }}</span>
      </div>
      <div
        class="col-12 col-sm-4 col-md-3 d-flex align-items-start flex-column justify-content-center"
        [ngClass]="rsf?.formStatus?.color"
      >
        <h1 id="serialNumber" [matTooltip]="rsf?.wfTable?.name ?? ''">
          {{ rsf?.serialNo }}
        </h1>
        <span>{{ rsf?.formStatus?.name }} </span>
      </div>
      <!-- Bug 6961: sit beside the serial number from sm up, and share one row with Created Date on phones -->
      <div class="col-6 col-sm-4 col-md-2 type-header d-flex align-items-center">
        <mat-form-field appearance="outline" *ngIf="rsf" class="no-subscript">
          <mat-label>Operator initiating form</mat-label>
          <input
            aria-label="operator"
            matInput
            type="text"
            name="operator_form"
            [ngModel]="rsf.createdBy?.name ?? ''"
            disabled
          />
        </mat-form-field>
      </div>
      <div class="col-6 col-sm-4 col-md-2 type-header d-flex align-items-center">
        <mat-form-field appearance="outline" *ngIf="rsf" class="no-subscript">
          <mat-label>Created Date</mat-label>
          <input
            matInput
            name="dateNow"
            placeholder="Date"
            disabled
            datetime="MM-dd-yyyy"
            [value]="rsf.createdOn | date: 'MMM-dd-yyyy'"
          />
        </mat-form-field>
      </div>
      <div
        class="col-12 col-md-3 d-flex flex-column justify-content-center align-items-end"
      >
        <!-- The warning component determines whether the current RSF workflow status requires verification. -->
        <worker-verification-warning
          [currentDocument]="rsf"
        ></worker-verification-warning>

        <div class="d-flex small" *ngIf="showAmendmentToggle">
          <mat-slide-toggle
            [ngModel]="isViewingAmendment"
            class="float-right d-print-none"
            (change)="toggleChanged($event)"
            >Show Pending Amendment</mat-slide-toggle
          >
        </div>
        <div class="d-flex small d-print-none" *ngIf="rsf?.editingBy">
          Modifying by:&nbsp;<b class="yellow">{{ rsf?.editingBy?.name }}</b>
        </div>
        <div
          class="d-flex small d-print-none"
          *ngIf="rsf?.canceledByID && rsf?.status == formStatusEnum.Canceled"
        >
          {{ "Canceled by:" }}&nbsp;<b class="red">{{
            rsf?.canceledBy?.name
          }}</b>
          on&nbsp;<b class="red">{{
            rsf?.canceledOn | date: "MMM-dd-yyyy HH:mm"
          }}</b>
          {{ rsf?.cancelReason ? " - Reason: " + rsf?.cancelReason : "" }}
        </div>
      </div>
    </div>
  </div>
</mat-toolbar>
